/**
 * @generated SignedSource<<d1e13a30eed95b6398cf2fdbfc337940>>
 * @relayHash ed71e29299509d8e9705e058551d2608
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75e1c12ba68b177c094b918bf2e7ac8201ccd17f72f6a8e11d15ef6291c40a15

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessOverviewCalendarQuery } from './src_jiraBusinessOverviewCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessOverviewCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "75e1c12ba68b177c094b918bf2e7ac8201ccd17f72f6a8e11d15ef6291c40a15",
    "metadata": {},
    "name": "src_jiraBusinessOverviewCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
